module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    attrs: {
      "table-ref": "landlordstable",
      "title": "Landlords",
      "icon": "fa fa-house",
      "url": "report/property/landlords",
      "fields": _vm.fields,
      "sort-field": "name",
      "search-placeholder": "Search Landlords...",
      "detail-component": "property-landlord-detail"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25e22830"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/property/PropertyLandlords.vue
// module id = 1462
// module chunks = 0